export const DateFormat = 'dd/MM/yyyy'
export const SimpleDateFormat = 'DD/MM/YYYY'
export const FullDateFormat = 'DD/MM/YYYY HH:mm'
export const NaturalDateFormat = 'dd MMMM yyyy'
export const TimeFormat = 'k.mm'
export const SimpleTimeFormat = 'HH:mm'
export const Version = '1.0.0'
export const AppName = 'Yupik'

export const MininumPswLength = 8
export const MaxLengthShortDescription = 140

export const MaxLengthEmailContent = 200

export const FileSize = 5000 * 1024
export const FileSupportedFormats = ['image/jpg', 'image/png', 'image/jpeg']

export const DaysOfTheWeek = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
]

export const EnableOwnerSubscription = false

export const defaultCoords = [45.401757, 8.8479805]

export const minOpeningHour = new Date().setHours(5, 0)
export const maxOpeningHour = new Date().setHours(24, 0)

export const GoogleMapApiKey = 'AIzaSyCl2HKegc4nCZuPyOU4tAW5Q1Xk8pvg2U4'
